import { useEffect, useState } from "react";
import axios from "axios";
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ComplianceCalendar() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");
  useEffect(() => { axios.get(`${BACKEND}/api/compliance-calendar`).then(r=>setItems(r.data)); }, []);
  const cats = ["All", ...Array.from(new Set(items.map(i=>i.category)))];
  const rows = filter === "All" ? items : items.filter(i=>i.category===filter);
  return (
    <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="chapter-num">Compliance Calendar</div>
        <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">Due dates,<br /><em className="italic text-[var(--pta-gold)]">up front.</em></h1>
        <p className="mt-8 max-w-2xl text-[var(--pta-ink)]/75 text-lg">A rolling view of the next quarter's statutory deadlines. Filter by category.</p>

        <div className="mt-10 flex flex-wrap gap-2">
          {cats.map(c => (
            <button key={c} data-testid={`filter-${c}`} onClick={()=>setFilter(c)} className={`px-3 py-2 font-mono-fine text-[10px] tracking-[0.2em] uppercase border ${filter===c?"bg-[var(--pta-navy)] text-[var(--pta-gold)] border-[var(--pta-navy)]":"hairline text-[var(--pta-ink)]/70 hover:border-[var(--pta-navy)]"}`}>{c}</button>
          ))}
        </div>

        <div className="mt-8 border hairline-navy">
          <div className="grid grid-cols-12 border-b hairline bg-[var(--pta-paper)] font-mono-fine text-[10px] tracking-[0.22em] uppercase text-[var(--pta-ink)]/60">
            <div className="col-span-3 p-4">Date</div>
            <div className="col-span-5 p-4">Compliance</div>
            <div className="col-span-2 p-4">Category</div>
            <div className="col-span-2 p-4">Authority</div>
          </div>
          {rows.map((r, i) => (
            <div key={i} data-testid={`calendar-row-${i}`} className="grid grid-cols-12 border-b hairline last:border-b-0 hover:bg-[var(--pta-paper)]/50 transition-colors">
              <div className="col-span-3 p-4 font-mono-fine text-[var(--pta-navy)]">{r.date}</div>
              <div className="col-span-5 p-4 font-serif-display text-lg text-[var(--pta-navy)]">{r.compliance}</div>
              <div className="col-span-2 p-4 font-mono-fine text-xs text-[var(--pta-gold)] uppercase tracking-widest">{r.category}</div>
              <div className="col-span-2 p-4 text-sm text-[var(--pta-ink)]/70">{r.authority}</div>
            </div>
          ))}
          {rows.length===0 && <div className="p-8 text-center text-[var(--pta-ink)]/60">No entries.</div>}
        </div>
      </div>
    </section>
  );
}
